export function interpolateTemplateText (text: string | undefined, parameters?: { type?: string, text?: string }[]): string {
  return (text || '').replace(/\{\{(\d+)\}\}/g, (placeholder, index) => {
    const value = parameters?.[Number(index) - 1]?.text
    return value || placeholder
  })
}

export function catalogPreviewLabels (language: string, businessName: string) {
  const name = businessName.trim()
  switch (language.split(/[_-]/)[0]) {
    case 'es':
      return {
        title: name ? `Ver el catálogo de ${name} en WhatsApp` : 'Ver catálogo en WhatsApp',
        subtitle: 'Explora fotos y detalles de sus ofertas.',
        button: 'Ver catálogo'
      }
    case 'fr':
      return {
        title: name ? `Voir le catalogue de ${name} sur WhatsApp` : 'Voir le catalogue sur WhatsApp',
        subtitle: 'Découvrez les photos et les détails de ses offres.',
        button: 'Voir le catalogue'
      }
    default:
      return {
        title: name ? `View the catalog of ${name} on WhatsApp` : 'View catalog on WhatsApp',
        subtitle: 'Explore photos and details of their offerings.',
        button: 'View catalog'
      }
  }
}

export function catalogImageUrl (imageUrl?: string | null): string {
  if (!imageUrl) return ''
  try {
    const url = new URL(imageUrl)
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : ''
  } catch {
    return ''
  }
}
